import axios from 'axios';

const get = async (page = 1, sort = 'date') =>
  (
    await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/pressrelease?page=${page}&sort=${sort}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
  ).data;

const getOnce = async (id) =>
  (
    await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/pressrelease/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
  ).data;

const getVoteActivated = async (id) =>
  (
    await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/pressrelease/like/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
  ).data;

const voteUp = async (id) =>
  (
    await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/pressrelease/like/${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
  ).data;

export default {
  get,
  getOnce,
  getVoteActivated,
  voteUp,
};
